import { GenericErrorBoundary } from "./GenericErrorBoundary";
import { BaseErrorBoundaryProps, FormContext, createFormState } from "./types";

interface Props extends BaseErrorBoundaryProps, FormContext {}

export function MultiStepFormErrorBoundary(props: Props) {
  const { children, onError, ...contextProps } = props;

  return (
    <GenericErrorBoundary
      componentName="MultiStepForm"
      errorBoundaryName="MultiStepFormErrorBoundary"
      componentType="MultiStepForm"
      title="Multi-Step Form Error"
      description="The multi-step form encountered an error. Please reload the page to continue with your document creation."
      buttonText="Reload Page"
      onError={onError}
      context={contextProps}
      stateData={createFormState(contextProps)}
    >
      {children}
    </GenericErrorBoundary>
  );
}
